export default "__VITE_ASSET__6RSGSau8__"